import { RandomId, StringHelper } from "@swivl-mono/helpers";
import { NodeInterface } from "@swivl-mono/types";
import { Switch } from "@swivl-mono/ui";
import { TagInput, TagInputType } from "../../../../Components/TagInput/TagInput";

import TabNodeLayoutData from "../NodeLayouts/TabNodeLayoutData";
import DelayComponent from "../SidePanel/Inspector/components/DelayComponent";
import InspectorFooter from "../SidePanel/Inspector/components/InspectorFooter";
import InspectorNodeHeader from "../SidePanel/Inspector/components/InspectorNodeHeader";
import NodePanel from "./NodePanel";
import _ from "lodash";
import { QuestsDropdown } from "../../../../Components/Dropdowns/QuestsDropdown/QuestsDropdown";

const SMS = {
  Type: "SMS",
  Empty: function () {
    let node = {
      "id": RandomId(6),
      "type": SMS.Type,
      "text": "",
      // "to": "",
      "goto": "",
      "invalidPhoneNumberGoto": "",
      "outboundQuest": "",
      "delay": 0,
      sendDirect: false
    }

    return node; //

  },
  PlumbData: function (node: NodeInterface) {
    const tabs = [{
      "id": "gotoSMS",
      "source": "goto",
      "target": node.goto,
      "title": "Sent",
    },
    {
      "id": "invalidPhoneNumberGoto",
      "source": "invalidPhoneNumberGoto",
      "target": node.invalidPhoneNumberGoto,
      "title": "Invalid Phone #",
    }
    ]

    const data = TabNodeLayoutData({
      node: node,
      title: "SMS",
      body: StringHelper.trimStringToLengthWithElipsis(node.text, 23),
      baseWidth: 180,
      bodyHeight: 40,
      tabs: tabs
    });

    return data
  },
  InspectorPanel: class InputInspectorPanel extends NodePanel {
    constructor(props: any) {
      super(props);
      this.onMessageChange = this.onMessageChange.bind(this)
    }

    onMessageChange(e: any) {
      let node = JSON.parse(JSON.stringify(this.props.node));

      if (e.target.value == this.props.node.text) {
        //SAME SAME!
      } else {
        var wordLength = this.props.node.text.split(" ").length;
        if (wordLength > 1) {
          var roundTo = Math.round((wordLength / 6) * 10) / 10;
          if (roundTo > 6) {
            _.set(node, "delay", 6)
          } else if (roundTo < 0.3) {
            _.set(node, "delay", 0.3);
          } else {
            _.set(node, "delay", roundTo.toString());
          }
        } else {
          _.set(node, "delay", 0.3);
        }
      }
      _.set(node, 'text', e.target.value);
      this.props.updateNode(node, this.props.node)
    }

    render() {
      return (<div>
        <div className="panel message_panel">
          <InspectorNodeHeader title="SMS" />
          <DelayComponent node={this.props.node} onChange={this.onChange} hideEllipsisOption={true} />

          {/* <label>Forward To</label>
          <TagInput type={TagInputType.SingleLine} value={this.props.node.to} onChange={this.onChange} name="to" placeholder="#User:PhoneNumber" /> */}
          <label>Initial Message</label>
          <TagInput
            key={"MessageTextInput_" + this.props.node.id}
            value={this.props.node.text}
            onChange={this.onMessageChange}
            name="text" />

          <label>Outbound Quest</label>
          <QuestsDropdown value={this.props.node.outboundQuest} name="outboundQuest" onChange={this.onChange} />
          <br />
          {/* <label>Send Direct (Not in Chat)</label>
                  <Switch  
                    on={this.props.node.sendDirect}
                    name="sendDirect"
                    onSet={(on:boolean, name?:string) => {
                      return this.onChangeSwitch(name!, on);
                    }}
                  /> */}
        </div>
        <InspectorFooter deleteNode={this.deleteNode} node={this.props.node} />
      </div>);

    }
  }
}
export default SMS;
